module.exports = __webpack_public_path__ + "img/CHEQUE-Circle-updated.59e3c2dd.png";